<template>
	<div :class="[color === 'orange' && 'c-full-width-info-block--orange',
	color === 'pink' && 'c-full-width-info-block--pink',
	color === 'blue' && 'c-full-width-info-block--blue',
	color === 'green' && 'c-full-width-info-block--green', className]">
		<div :class="[
			'c-full-width-info-block__content',

		]">
			<div class="c-full-width-info-block__image-wrapper">
				<img :src="src" :alt="alt || ''" v-if="!isSvg" />

				<svg width="200" height="200" xmlns="http://www.w3.org/2000/svg" v-if="isSvg">
					<image :href="src" height="200" width="200" />
				</svg>
			</div>
			<div class="c-full-width-info-block__content-wrapper">
				<h2 class="c-full-width-info-block__heading heading-boarder">
					{{ heading }}
				</h2>
				<p v-if="text" class="c-full-width-info-block__text">{{ text }}</p>
				<a v-if="url && buttonText" :href="url" class="c-full-width-info-block__link">
					<span>{{ buttonText }}</span>
					<v-icon name="icon-chevron" size="xxs" cssModifiers="c-full-width-info-block__icon"></v-icon>
				</a>
			</div>

		</div>
	</div>
</template>

<script>
import VIcon from "../../components/icon/VIcon.vue";

export default {
	name: "VFullWidthInfoBlock",
	components: {
		VIcon
	},
	computed: {
		isSvg() {
			return this.src.includes('.svg');
		}
	},
	props: {
		heading: {
			type: String
		},
		text: {
			type: String
		},
		url: {
			type: String
		},
		buttonText: {
			type: String
		},
		src: {
			type: String
		},
		alt: {
			type: String
		},
		color: {
			type: "orange" | "blue" | "pink"
		},
		className: {
			type: String
		}
	}
};
</script>
